<ng-container *ngIf="!blankNodeType && isEditable && showForm">

  <form [formGroup]="form" (ngSubmit)="onSubmit($event);" class="row" *ngIf="Object.keys(form.controls).length">
    <p class="pl-3 pt-3 mb-0">Fields marked with an asterisk (<span class="mandatory">*</span>)
      are required.</p>

    <div class="form-group col-12" role="alert">
      <p class="text-danger mb-0 mt-0" *ngIf="isAllFieldFilled"><span class="sr-only">Error</span> Some required fields
        are yet to be added.</p>
    </div>

    <ng-container *ngFor="let controls of metadataList; let i = index;">

      <div class="form-group col-11 pr-0" *ngIf="uuidValue && isEditable && i===0">
        <p class="font-bold mb-1" id="{{'uuid-'+i}}">
          UUID </p>
        <p class="mb-0 text-wrapped" id="{{uuidValue+'-'+i}}">{{uuidValue}}</p>
      </div>
      <!-- NodeType-->

      <!-- Editable -->
      <div class=" dropdown form-group col-4" *ngIf="nodeType && isEditable && i===0">
        <app-auto-complete [disabled]="(selectedNodetype && selectedNodetype.is_document===1) || templateSelected" [listingObj]="nodetypeList"
          (selectedObject)="onChangeNodetype($event)" [selectType]="'single'" [uniqueId]="'node_type_id'"
          [propName]="'title'" [defaultSelection]="selectedNewNodetype" [autoCompleteTitle]="autoCompleteTitle"
          [isMandatory]="true" [isLableShow]="false" [showValidMsg]="true" [canDelete]="false"
          [disableOptionList]="disableOptionList" #autoComplete>
        </app-auto-complete>
      </div>
      <!-- End of Editable -->

      <!-- Taxonomy Type STARTS -->

      <div class="form-group col-12"
        *ngIf="nodeType && isEditable && i===0 && selectedNodetype && selectedNodetype.is_document===1">
        <div class="row justify-content-between">
          <div class="col-11 pr-0">
            <label class="font-bold mb-0" id="taxotypeLabel" for="NodeType">
              Taxonomy Type </label>
            <select id="taxonomyType" [(ngModel)]="selectedTaxonomyType" [ngModelOptions]="{standalone: true}"
              class="custom-select" (change)="onChange($event)">
              <option *ngFor="let type of taxonomyTypeList;let i = index"
                id="{{ type.label.split(' ').join('')+'label'+i}} }}" [ngValue]="type.value">
                {{ type.label }}
              </option>
            </select>
          </div>
        </div>

      </div>

      <!-- Taxonomy Type ENDS -->

      <!-- CASE Status STARTS -->

      <div class="form-group col-12"
        *ngIf="nodeType && isEditable && i===0 && selectedNodetype && selectedNodetype.is_document===1">
        <div class="row justify-content-between">
          <div class="col-11 pr-0">
            <label class="font-bold mb-0" id="casestatusLabel" for="NodeType">
              CASE Status </label>
            <select id="caseStatus" [(ngModel)]="selectedCASEstatus" [ngModelOptions]="{standalone: true}"
              class="custom-select" (change)="onChange($event)" [disabled]="!caseStatusPermission">
              <option *ngFor="let status of statusList; let i =index"
                id="{{ status.label.split(' ').join('')+'label'+i}} }}" [ngValue]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
        </div>

      </div>

      <!-- CASE Status ENDS -->
      <!-- END of NodeType -->
      <div class="{{isMandatory(controls.internal_name) ? 'form-group col-12' : 'form-group col-12'}}"
        *ngIf="(controls.is_custom===0? form?.get(controls.internal_name)?.value : form?.get(controls.metadata_id)?.value ) || isEditable">
        <!-- Editable-->
        <div class="row justify-content-between">
          <div class="col-11 pr-0">
            <label *ngIf="controls.is_custom===0 && isEditable" for="{{controls.internal_name}}" class="font-bold"
              id="{{controls.name}}_Label_{{isMandatory(controls.internal_name)}}">
              {{controls.name}}
              <span *ngIf="isMandatory(controls.internal_name)" class="font-bold mandatory" aria-hidden="true">
                *</span>
              <button type="button"  *ngIf="chatEnabled && controls.is_comment" (click) ="openCommentSec(controls)" aria-label="Comment" class="btn btn-ds--secondary btn-icon btn-rounded btn-sm px-2 py-1 mx-1">
                  <span aria-hidden="true" class="material-icons-outlined font-2x">chat_bubble_outline</span>
              </button>
              <button class="btn btn-icon tooltip top lg position-relative d-inline-block control-info mt-1"
                id="casefieldBtn_{{controls.internal_name ? controls.internal_name : controls.metadata_id}}"
                [attr.aria-label]="getCaseField(controls.internal_name)"
                [attr.data-tooltip]="getCaseField(controls.internal_name) + (controls.internal_name === 'concept_keywords_list' ? ' (' + extraLabel + ')' : '')"
                *ngIf="(controls.name !== getCaseField(controls.internal_name)) || (controls.internal_name === 'concept_keywords_list')">
                <em class="material-icons-outlined font-4x" aria-hidden="true">error_outline</em>
              </button>
            </label>
            <input id="{{controls.internal_name }}_{{isMandatory(controls.internal_name)}}"
              *ngIf="controls.field_type===1 && controls.is_custom===0 && isEditable && !validate(controls)"
              [style.display]="hideControl(controls)? 'none':'block'" type="text" class="form-control"
              [attr.aria-label]="'Please enter '+controls.internal_name" formControlName="{{controls.internal_name}}"
              (keyup)="onChange($event)" value="{{extractContent(form?.get(controls.internal_name)?.value)}}">

            <div class="mb-0 form-control custom-field cursor-pointer"
              id="{{controls.internal_name }}_{{isMandatory(controls.internal_name)}}"
              *ngIf="(controls.field_type===1 || controls.field_type===2 ) && controls.is_custom===0 && isEditable && validate(controls)"
              [mathJax]="getHtml(controls)" (click)="openEditor(controls,form.controls);showEditor = true"
              data-target="#openEditor" [style.display]="hideControl(controls)? 'none':'block'"></div>


            <!-- Editable-->
            <textarea id="{{controls.internal_name }}_{{isMandatory(controls.internal_name)}}"
              [style.display]="hideControl(controls)? 'none':'block'"
              *ngIf="controls.field_type===2 && controls.is_custom===0 && isEditable && !validate(controls)"
              class="form-control font-bold" [attr.aria-label]="'Please enter '+controls.internal_name"
              formControlName="{{controls.internal_name}}" (keyup)="onChange($event); autoGrow(controls.internal_name)"
              (blur)="autoGrow(controls.internal_name)"
              value="{{extractContent(form?.get(controls.internal_name)?.value)}}"></textarea>


            <!-- Editable -->
            <select id="{{controls.internal_name }}_{{isMandatory(controls.internal_name)}}"
              *ngIf="controls.field_type===3 && controls.is_custom===0 && isEditable" [ngModel]="selectedLanguage"
              [attr.disabled]="!isEditable ? true : null" class="form-control custom-select"
              formControlName="language_name" (change)="onChange($event)">
              <option [ngValue]="''">Select</option>
              <option [ngValue]="lang" *ngFor="let lang of languages ; let i =index"
                id="{{ lang.display_text.split(' ').join('')+'label'+i}} }}">{{ lang.display_text }}</option>
            </select>


            <div class="date-picker" *ngIf="controls.is_custom===0 && controls.field_type===4">

              <!-- Editable -->
              <my-date-picker id="{{controls.internal_name}}"
                *ngIf="controls.internal_name==='status_start_date' && isEditable"
                [options]="myDatePickerOptionsStartDate"
                (dateChanged)="onStartDateChanged($event);onDateFieldChange($event, controls.internal_name)"
                formControlName="{{controls.internal_name}}" (change)="onChange($event)"></my-date-picker>

              <!-- Editable -->
              <my-date-picker id="{{controls.internal_name}}"
                *ngIf="controls.internal_name==='status_end_date' && isEditable" [options]="myDatePickerOptionsEndDate"
                (dateChanged)="onEndDateChanged($event);onDateFieldChange($event, controls.internal_name)"
                formControlName="{{controls.internal_name}}" (change)="onChange($event)"></my-date-picker>

            </div>


            <div
              *ngIf="controls.internal_name ==='official_source_url' && controls.is_custom===0 && view==='project-authoring'">
              <div
                *ngIf="form.controls['official_source_url'].touched && form.controls['official_source_url'].hasError('pattern')"
                role="alert">
                <p class="font-bold m-0"><span class="sr-only">Error</span> Please enter a valid url.</p>
              </div>
            </div>



            <!-- Editable -->
            <label *ngIf="controls.is_custom===1 && isEditable" for="{{controls.metadata_id}}"
              id="{{controls.name.split(' ').join('')+'_label_'+ isMandatory(controls.metadata_id)}}"> {{controls.name}}
              <span *ngIf="isMandatory(controls.metadata_id)" class="font-bold mandatory" aria-hidden="true">
                *</span></label>
              <button type="button"  *ngIf="chatEnabled && controls.is_custom===1 && isEditable && controls.is_comment" (click) ="openCommentSec(controls)" aria-label="Comment" class="btn btn-ds--secondary btn-icon btn-rounded btn-sm px-2 py-1 mx-1">
                  <span aria-hidden="true" class="material-icons-outlined font-2x">chat_bubble_outline</span>
              </button>
            <input id="{{controls.metadata_id}}_{{isMandatory(controls.metadata_id)}}"
              [style.display]="hideControl(controls)? 'none':'block'"
              *ngIf="controls.field_type===1 && controls.is_custom===1 && isEditable && !validate(controls)" type="text"
              class="form-control font-bold" [attr.aria-label]="'Please enter '+controls.name"
              formControlName="{{controls.metadata_id}}" (keyup)="onChange($event)">

            <div id="{{controls.metadata_id}}_{{isMandatory(controls.metadata_id)}}"
              class="mb-0 form-control font-bold custom-field cursor-pointer"
              *ngIf="(controls.field_type===1 || controls.field_type===2 ) && controls.is_custom===1 && isEditable && validate(controls)"
              [mathJax]="getHtml(controls)" (click)="openEditor(controls,form.controls);showEditor = true"
              data-target="#openEditor" [style.display]="hideControl(controls)? 'none':'block'"></div>


            <!-- Editable -->
            <textarea id="{{controls.metadata_id}}_{{isMandatory(controls.metadata_id)}}"
              [style.display]="hideControl(controls)? 'none':'block'"
              *ngIf="controls.field_type===2 && controls.is_custom===1 && isEditable && !validate(controls)"
              class="form-control font-bold" [attr.aria-label]="'Please enter '+controls.name"
              formControlName="{{controls.metadata_id}}" (keyup)="onChange($event);autoGrow(controls.metadata_id)"
              (blur)="autoGrow(controls.metadata_id)"></textarea>

            <ng-container *ngIf="controls.is_custom===1">
              <ng-container *ngFor="let obj of allCustomDropdowns">
                <select id="{{controls.metadata_id}}_{{isMandatory(controls.metadata_id)}}"
                  *ngIf="controls.field_type===3 && obj.metadata_id === controls.metadata_id && isEditable"
                  [ngModel]="obj.selectedObj" [attr.disabled]="!isEditable ? true : null"
                  class="form-control custom-select" formControlName="{{controls.metadata_id}}"
                  (change)="onChange($event)">
                  <option [ngValue]="val" *ngFor="let val of obj.data">{{ val }}</option>
                </select>
                <p *ngIf="controls.field_type===3 && obj.metadata_id === controls.metadata_id && !isEditable"
                  class="mb-0">
                  {{obj.selectedObj}}</p>
              </ng-container>
            </ng-container>

            <div class="date-picker" *ngIf="controls.is_custom===1">

              <!-- Editable -->
              <my-date-picker *ngIf="controls.field_type===4 && isEditable" id="{{'cust'+controls.metadata_id}}"
                [disabled]="!isEditable ? true : null" [options]="myDatePickerOptionsStartDate"
                (dateChanged)="onCustomDateChanged($event,controls.metadata_id);onDateFieldChange($event, 'cust'+controls.metadata_id, controls.metadata_id)"
                formControlName="{{controls.metadata_id}}" (change)="onChange($event)"></my-date-picker>


            </div>


            <ng-container *ngIf="controls.is_custom===1">
              <ng-container *ngFor="let obj of timeObj">
                <!-- Editable -->
                <input class="form-control font-bold" (blur)="onTimeFieldBlur($event)"
                  id="{{controls.metadata_id.split(' ').join('')}}"
                  *ngIf="controls.field_type===5 && obj.metadata_id === controls.metadata_id && isEditable"
                  [attr.disabled]="!isEditable ? true : null" type="text" atp-time-picker value="{{obj.data}}"
                  (ngModelChange)="onChange($event);onCustomTimeChanged($event,obj.metadata_id)"
                  formControlName="{{controls.metadata_id}}" atp-time-picker />

              </ng-container>
            </ng-container>

            <ng-container>
              <input *ngIf="controls.field_type===6 && controls.is_custom===1 && isEditable" type="text"
                (keypress)="isNumber($event)" class="form-control font-bold"
                id="{{controls.metadata_id.split(' ').join('')}}" [attr.aria-label]="'Please enter '+controls.name"
                formControlName="{{controls.metadata_id}}" (keyup)="onChange($event)">
              <p *ngIf="controls.field_type===6 && controls.is_custom===1 && !isEditable" class="mb-0">
                {{form?.get(controls.metadata_id)?.value}}</p>
            </ng-container>

            <ng-container *ngIf="checkRichTextEditorShow(controls) && showEditor">
              <!--animated slideInDown delay-2s-->
              <app-text-editor #textEditor (updateField)="updateFieldFromEditor($event);"
                (updateShowEditor)="updateShowEditor($event);" (checkSourceLengthEvent)="checkCharLength($event)">
              </app-text-editor>
            </ng-container>

          </div>

          <div class="col-1 mt-4 pl-0 pt-1"
            *ngIf="(controls.field_type===1 || controls.field_type===2) && isEditable && validate(controls) && !showEditor">
            <button [attr.aria-label]="'Click to edit'" (click)="openEditor(controls,form.controls);showEditor = true"
              type="button" class="btn btn-edit btn-clear tooltip top sm font-1x position-relative"
              id="openediterBtn_{{controls.internal_name? controls.internal_name: controls.metadata_id}}"
              data-tooltip="Edit" data-toggle="modal" aria-label="Open Editor" data-target="#openEditor"><span
                class="sr-only">Opens in a new dialog</span>
              <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
            </button>
          </div>

        </div>

      </div>
    </ng-container>
    <button id="formSubmit" type="submit" (click)="onSubmit($event);" hidden>Submit</button>
  </form>
</ng-container>

<!-- Read only starts -->
<ng-container *ngIf="metadataList && metadataList.length > 0 && !isEditable && !blankNodeType && showForm">
  <!-- <div class="col-12 d-flex justify-content-end" [ngStyle]="{'margin-top': margin_val}"
    *ngIf="showUserFriendlyPage && lastSelectedNode.isDocument === 0">
    <a [attr.href]="currentPathPrefix + '?id=' + lastSelectedNode.node_id + '&isDocument=' + lastSelectedNode.isDocument"
      target="_blank" class="btn btn-clear p-1 tooltip left position-relative" data-tooltip="View node details"
      aria-label="view node details">
      <em class="material-icons-outlined font-4x" aria-hidden="true">open_in_new</em>
    </a>
  </div> -->
  <div [ngClass]="{'expanded': showMore, 'mt-uuid':viewLocation==='project-auth'}"
    class="justify-content-center col-12 pt-2 px-0 position-relative readonly mb-3">

    <form id="form_container" [formGroup]="form" class="row mt-0">

      <ng-container *ngFor="let controls of metadataList; let i = index;">

        <div class="col-12 px-3 py-2 px-4" *ngIf="uuidValue && !isEditable && i===0">
          <p class="font-bold mb-0" id="{{'uuid-'+i}}">
            UUID</p>
          <p class="mb-0 text-wrapped" id="{{uuidValue+'-'+i}}">{{uuidValue}}
          </p>
        </div>

        <div class="col-12 px-3 py-2 px-4" [ngClass]="[uuidValue ? 'border-top' : '']"
          *ngIf="nodeType && !isEditable && i===0">
          <p class="font-bold mb-0" id="{{'nodetype-'+i}}">
            Node Type</p>
          <p class="mb-0 text-wrapped" id="{{nodeType+'-'+i}}">{{nodeType}}
          </p>
        </div>

        <div class="col-12 px-3 py-2 px-4 border-top"
          *ngIf="selectedTaxonomyTypeText && nodeType === 'Document' && i===0">
          <p class="font-bold mb-0" id="{{'taxonomytype-'+i}}">
            Taxonomy Type</p>
          <p class="mb-0 text-wrapped" id="{{selectedTaxonomyTypeText+'-'+i}}">{{selectedTaxonomyTypeText}}
          </p>
        </div>

        <div class="col-12 px-3 py-2 px-4 border-top"
          *ngIf="selectedCASEstatusText && nodeType === 'Document' && i===0">
          <p class="font-bold mb-0" id="{{'casestatus-'+i}}">
            CASE Status</p>
          <p class="mb-0 text-wrapped" id="{{selectedCASEstatusText+'-'+i}}">{{selectedCASEstatusText}}
          </p>
        </div>

        <div class="col-12 px-3 py-2 px-4 border-top"
          *ngIf="(controls.is_custom===0? form?.get(controls.internal_name)?.value : form?.get(controls.metadata_id)?.value )">

          <p class="font-bold mb-0" *ngIf="controls.is_custom===0 && !isEditable">
            {{controls.name}}
            <button class="btn btn-icon tooltip top lg position-relative d-inline-block control-info mt-1"
              id="casefBtn" [attr.aria-label]="getCaseField(controls.internal_name)"
              [attr.data-tooltip]="getCaseField(controls.internal_name)"
              *ngIf="controls.name !== getCaseField(controls.internal_name)">
              <em class="material-icons-outlined font-4x" aria-hidden="true">error_outline</em>
            </button>
          </p>

          <p *ngIf="controls.field_type===1 && controls.is_custom===0 && !isEditable" class="mb-0 text-wrapped"
            [mathJax]="form?.get(controls.internal_name)?.value">
          </p>

          <p class="mb-0 text-wrapped" *ngIf="controls.field_type===2 && controls.is_custom===0 && !isEditable"
            [mathJax]="form?.get(controls.internal_name)?.value"></p>

          <p class="mb-0 text-wrapped"
            *ngIf="controls.field_type===3 && controls.is_custom===0 && !isEditable && selectedLanguage">
            {{selectedLanguage.display_text}}</p>

          <p class="font-bold mb-0" *ngIf="controls.is_custom===1 && !isEditable" [attr.for]="controls.metadata_id">
            {{controls.name}}</p>

          <pre *ngIf="controls.field_type===1 && controls.is_custom===1 && !isEditable" class="font-2x mb-0 text-wrapped"
            [mathJax]="form?.get(controls.metadata_id)?.value"></pre>

          <pre *ngIf="controls.field_type===2 && controls.is_custom===1 && !isEditable" class="font-2x mb-0 text-wrapped"
            [mathJax]="form?.get(controls.metadata_id)?.value"></pre>

          <div class="date-picker" *ngIf="controls.is_custom===0">
            <p class="mb-0 text-wrapped"
              *ngIf="controls.field_type===4 && controls.internal_name==='status_start_date' && !isEditable">
              {{!isFormatChange ? nodeDetails['status_start_date'] : nodeDetails['status_start_date'] | date: 'MM-dd-yyyy'}}</p>
            <p class="mb-0 text-wrapped"
              *ngIf="controls.field_type===4 && controls.internal_name==='status_end_date' && !isEditable">
              {{!isFormatChange ? nodeDetails['status_end_date'] : nodeDetails['status_end_date'] | date: 'MM-dd-yyyy' }}</p>
          </div>

          <ng-container *ngIf="controls.is_custom===1">
            <ng-container *ngFor="let obj of allCustomDropdowns">
              <p *ngIf="controls.field_type===3 && obj.metadata_id === controls.metadata_id && !isEditable"
                class="mb-0">
                {{obj.selectedObj}}</p>
            </ng-container>
          </ng-container>

          <div class="date-picker col-12 px-2 pb-2" *ngIf="controls.is_custom===1">
            <p *ngIf="controls.field_type===4 && !isEditable" class="mb-0">
              {{getDate(form?.get(controls.metadata_id)?.value)}}</p>
          </div>

          <ng-container *ngIf="controls.is_custom===1">
            <ng-container *ngFor="let obj of timeObj">
              <p *ngIf="controls.field_type===5 && obj.metadata_id === controls.metadata_id && !isEditable"
                class="mb-0">
                {{form?.get(controls.metadata_id)?.value}}</p>
            </ng-container>
          </ng-container>

          <ng-container>
            <p *ngIf="controls.field_type===6 && controls.is_custom===1 && !isEditable" class="mb-0">
              {{form?.get(controls.metadata_id)?.value}}</p>
          </ng-container>

        </div>
      </ng-container>
    </form>

    <div *ngIf="itemHeight > 300" class="w-100 text-center border-top view-all"
      [ngClass]="showMore ? 'position-relative' : 'position-absolute'">
      <button class="btn btn-clear btn-link text-underline" id="chngviewBtn" (click)="changeView()">
        {{showMore ? 'View Less' : 'View All'}}
      </button>
    </div>
  </div>
</ng-container>